import { AuthService } from './auth.service';
import { matrix } from '../interface/matrix';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
    
  constructor(private authService: AuthService) { }

  /* Task List as applicable in application */
  public taskList = {
    access:{
      mda: "MDAuser",
      mdr: "MDAReports",
      sst: "AccessSST",
      bulkUpload: "AccessBulkUpload",
      xpwd: "AccessXPWD",
      extadmin: "ExtendedAdminAccess",
      open: "OpenAccess"
    }
  }

  /* Permission Matrix Role X Task */
  private readonly permissionMatrix : matrix = {
    mda : [
      this.taskList.access.mda,
      this.taskList.access.sst,
      this.taskList.access.bulkUpload,
      this.taskList.access.xpwd
    ],
    mdr : [
      this.taskList.access.mda,
      this.taskList.access.mdr
    ],
    extadmin : [
      this.taskList.access.extadmin
    ]
  }

  private validateAccess(task: string) : boolean{
    const loggedInUser = this.authService.currentUserValue;
    console.log("=>",loggedInUser, this.permissionMatrix)
    if (!loggedInUser) return false;
    
    if (task == this.taskList.access.open) return true;
    
    return loggedInUser.roles.some((role : any) => this.permissionMatrix[role]?.includes(task))
  }

  /* 
  Public Method to Validate user access
    returns Boolean
  */
  public canAccess(task: string){
   
    if(this.validateAccess(task))
    return true

    return false
  }
}
